import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const BillOfMaterialsService = {

    async getByCode(code, select = null) {
        const requestScreenData = {
            url: "api/BOMNEW",
            top: "1",
            filter: `Code eq '${code}'`,
            // select:
            //     "Code,QuoteCode,BomCode,ShipDate,ScheduledDate,ItemQty,DivisionCode,BranchCode,Comment,ProductCode,CreatedBy,DateCreated,DateCompleted,ChangedBy,DateChanged,FriendlyStatus,MTSQuantity,SalesOrderStockUMQuantity,ActualQty,Status,TotalSortHour,TotalTegraHour,TotalLabourHour,TotalDownTimeHour,DownTimeComment, ReleaseDepartmentCode, ReleaseDepartmentName, PlannedCompletionDate",
        };

        if (select) {
            requestScreenData.select = select;
        }

        return await ApiService.oDataGet(requestScreenData);
    },


    dataSourceConfig(url, params) {
        return ApiService.createDataSource(url, params);
    },

    getBOMProcessesMaxSeqNo(bomCode) {
        const requestScreenData = {
            url: `api/BomProcessList?$apply=filter(BomCode eq '${bomCode}')/aggregate(SeqNo with max as MaxSeqNo)`,
        };
        return ApiService.oDataGet(requestScreenData);
    },

    getAddedMaterialProcesses(bomCode) {
        const requestScreenData = {
            url: `api/BomProcessList?$apply=filter(BomCode eq '${bomCode}')/groupby((ProcessCode))`,
        };
        return ApiService.oDataGet(requestScreenData);
    },

    saveBOM(payload) {
        return ApiService.post("api/BomNew/SaveBomNewHeader", payload);
    },

    SaveBomNewProcess(payload) {
        return ApiService.post("api/BomNew/SaveBomNewProcess", payload);
    },


    getBomProcessByRecordId(recordId) {
        const requestScreenData = {
            url: `api/BomProcessList`,
            filter: `RecordId eq ${recordId}`,
        };
        return ApiService.oDataGet(requestScreenData);
    },

    getAddedProductsForProcess(processCode, billNo) {
        const requestScreenData = {
            url: `api/BomMaterialList`,
            filter: `ProcessCode eq '${processCode}' and BomCode eq '${billNo}'`,
            select: "ProcessCode,BomCode,MaterialCode",
        };
        return ApiService.oDataGet(requestScreenData);
    },

    getBomMaterialByRecordId(recordId) {
        const requestScreenData = {
            url: `api/BomMaterialList`,
            filter: `RecordId eq ${recordId}`,
        };
        return ApiService.oDataGet(requestScreenData);
    },

    SaveBomNewMaterial(payload) {
        return ApiService.post("api/BomNew/SaveBomNewMaterial", payload);
    },

    getAddedBOMForProcess(ProcessCode, BillNo) {
        const requestScreenData = {
            url: `api/BomAssemblyList`,
            filter: `ProcessCode eq '${ProcessCode}' and BomCode eq '${BillNo}'`,
            select: "ProcessCode,BomCode",
        };
        return ApiService.oDataGet(requestScreenData);
    },

    SaveBomNewAssembly(payload) {
        return ApiService.post("api/BomNew/SaveBomNewAssembly", payload);
    },

    getBomAssemblyByRecordId(recordId) {
        const requestScreenData = {
            url: `api/BomAssemblyList`,
            filter: `RecordId eq ${recordId}`,
        };
        return ApiService.oDataGet(requestScreenData);
    },

    deleteBomProcess(recordId) {
        return ApiService.post(`api/BomNew/DeleteBomNewProcess/${recordId}`);
    },

    deleteBomMaterial(recordId) {
        return ApiService.post(`api/BomNew/DeleteBomNewMaterial/${recordId}`);
    },

    deleteBomAssembly(recordId) {
        return ApiService.post(`api/BomNew/DeleteBomNewAssembly/${recordId}`);
    },

    saveCopyBOM(IsBOMAndProduct, payload) {
        let url = "api/BomNew/CopyBom";
        if (IsBOMAndProduct) {
            url = "api/BomNew/CopyBomWithProduct";
        }
        return ApiService.post(url, payload);
    },

    updateMaterialSubstitute(payload) {
        return ApiService.post("api/BomNew/MaterialSubstitution", payload);
    },

    saveCopyBomList(payload) {
        return ApiService.post("api/BomNew/CopyBomList", payload);
    },


}

export { BillOfMaterialsService };